import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-valuer-pv.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-valuer-pv.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { WorkflowJobService } from "../../../../../shared/services/workflow-job/workflow-job.service";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AlertType } from "../../../../../shared/models/alert";
import { AppControllerService } from "../../../../../app-controller.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { ViewApplicationValuerPvConstants } from "./view-application-valuer-pv.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ViewApplicationService } from "../../../view-application.service";
import { RecipientSelectService } from "../../../../../shared/components/recipient-select/shared/service/recipient-select.service";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { RecipientListService } from "src/app/shared/components/recipient-list/shared/recipient-list.service";
import { take, takeUntil } from "rxjs/operators";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { CurrentStepService } from "src/app/shared/services/current-step/current-step.service";
let ViewApplicationValuerPvComponent = class ViewApplicationValuerPvComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    recipientListService;
    route;
    jobService;
    currentStepsService;
    appController;
    routerParamsService;
    changeDetectorRefs;
    recipientSelectService;
    viewApplicationService;
    valuerForm;
    municipalValuerDisableFilterBy = false;
    municipalValuerDisableAdd = true;
    municipalValuerDisableEditing = true;
    municipalValuerShowFields = true;
    municipalValuerIsInternal = false;
    municipalValuerGroups = [];
    municipalValuerLabel = ViewApplicationValuerPvConstants.MUNICIPAL_LABEL;
    municipalValuerFormControlName = ViewApplicationValuerPvConstants.MUNICIPAL_VALUER_FORM_CONTROL_NAME;
    assistantValuerDisableFilterBy = false;
    assistantValuerDisableAdd = true;
    assistantValuerDisableEditing = false;
    assistantValuerGroups = [];
    assistantValuerListLabel = ViewApplicationValuerPvConstants.ASSISTANT_VALUERS_LABEL;
    assistantValuerFormControlName = ViewApplicationValuerPvConstants.ASSISTANT_VALUER_FORM_CONTROL_NAME;
    dataCollectorListLabel = ViewApplicationValuerPvConstants.DATA_COLLECTORS_LABEL;
    dataCollectorDisableFilterBy = false;
    dataCollectorDisableAdd = true;
    dataCollectorDisableEditing = false;
    dataCollectorGroups = [];
    dataCollectorFormControlName = ViewApplicationValuerPvConstants.DATA_COLLECTOR_FORM_CONTROL_NAME;
    saveBtnPlaceholder = ViewApplicationValuerPvConstants.SAVE_BUTTON_PLACEHOLDER;
    application;
    getApplicationSaveApplicantObservableSubscription;
    getStepMetaObservableSubscription;
    constructor(aflaModuleStrategyService, recipientListService, route, jobService, currentStepsService, appController, routerParamsService, changeDetectorRefs, recipientSelectService, viewApplicationService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.recipientListService = recipientListService;
        this.route = route;
        this.jobService = jobService;
        this.currentStepsService = currentStepsService;
        this.appController = appController;
        this.routerParamsService = routerParamsService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.recipientSelectService = recipientSelectService;
        this.viewApplicationService = viewApplicationService;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        this.getMetadata();
        this.currentStepsService.setShowStepSave(false);
        this.currentStepsService.setShowStepContinue(true);
    }
    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }
    handleRouteChange() {
        // this.getMetadata();
    }
    onBtnSaveClicked() {
        if (this.valuerForm.valid) {
            const municipalValuerFormValue = this.valuerForm.get("municipalValuerRecipient").value;
            const municipalValuer = RecipientUtils.removeRecipientProperties(municipalValuerFormValue);
            const assistantValuerFormValue = this.valuerForm.get("assistantValuerRecipient").value;
            const dataCollectorFormValue = this.valuerForm.get("dataCollectorRecipient").value;
            let assistantValuers = [];
            let dataCollectors = [];
            if (assistantValuerFormValue !== undefined && assistantValuerFormValue !== null && assistantValuerFormValue.hasOwnProperty("recipients")) {
                assistantValuers = assistantValuerFormValue.recipients;
                assistantValuers.forEach((assistant) => {
                    RecipientUtils.removeRecipientProperties(assistant);
                });
            }
            if (dataCollectorFormValue !== undefined && dataCollectorFormValue !== null && dataCollectorFormValue.hasOwnProperty("recipients")) {
                dataCollectors = dataCollectorFormValue.recipients;
                dataCollectors.forEach((dataCollector) => {
                    RecipientUtils.removeRecipientProperties(dataCollector);
                });
            }
            const request = {
                municipalValuer,
                assistantValuers,
                dataCollectors
            };
            this.getApplicationSaveApplicantObservableSubscription =
                this.viewApplicationService.getApplicationSaveApplicantObservable(this.aflaModuleStrategyService.applicationServiceUrl, this.aflaModuleStrategyService.setApplicantAndApplicantAgentAction, this.application.id, request).subscribe({
                    next: () => {
                        this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                        this.getApplicantData();
                    }, error: error => {
                        this.appController.handleServerErrorMessage(ViewApplicationValuerPvConstants.STEP_TITLE, error, CRUDOperation.Update);
                    }
                });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    initForm() {
        this.valuerForm = this.aflaModuleStrategyService.form.get("valuerForm");
    }
    getMetadata() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        try {
            this.municipalValuerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(stepMeta.municipalValuerGroup);
            this.assistantValuerGroups = this.recipientListService.checkStepMetaRecipientGroups(stepMeta.assistantValuerGroup);
            this.dataCollectorGroups = this.recipientListService.checkStepMetaRecipientGroups(stepMeta.dataCollectorGroup);
        }
        catch (e) {
            this.appController.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
        this.getApplicantData();
    }
    getApplicantData() {
        const params = {
            $filter: `jobId eq ${this.jobID} and moduleId eq ${this.moduleID}`,
            $expand: `municipalValuer($expand=groups)`
        };
        this.aflaModuleStrategyService.getApplicationsQuery(params).subscribe((returnValue) => {
            this.application = returnValue.value[0];
            const municipalValuerControl = this.valuerForm.get("municipalValuerRecipient");
            const municipalValuer = this.application.municipalValuer[0];
            this.recipientSelectService.setRecipient(municipalValuer, false, municipalValuerControl);
            municipalValuerControl.markAsTouched();
            this.viewApplicationService.getAssistantValuers(+this.jobID).pipe(takeUntil(this._destroy$), take(1)).subscribe((returnAssistantValue) => {
                if (returnAssistantValue.assistantValuers.length > 0) {
                    const assistantValuerControl = this.valuerForm.get(this.assistantValuerFormControlName);
                    this.recipientListService.setRecipients(returnAssistantValue.assistantValuers, false, assistantValuerControl);
                    this.changeDetectorRefs.detectChanges();
                }
            });
            this.viewApplicationService.getDataCollectors(+this.jobID).pipe(takeUntil(this._destroy$), take(1)).subscribe((returnDataCollectorsValue) => {
                if (returnDataCollectorsValue.dataCollectors.length > 0) {
                    const dataCollectorControl = this.valuerForm.get(this.dataCollectorFormControlName);
                    this.recipientListService.setRecipients(returnDataCollectorsValue.dataCollectors, false, dataCollectorControl);
                    this.changeDetectorRefs.detectChanges();
                }
            });
        });
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: RecipientListService },
        { type: ActivatedRoute },
        { type: WorkflowJobService },
        { type: CurrentStepService },
        { type: AppControllerService },
        { type: RouterParamsService },
        { type: ChangeDetectorRef },
        { type: RecipientSelectService },
        { type: ViewApplicationService }
    ];
};
ViewApplicationValuerPvComponent = __decorate([
    Component({
        selector: "app-view-application-valuer-pv",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationValuerPvComponent);
export { ViewApplicationValuerPvComponent };
